import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSparkles } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { CC_PANEL } from "@/components/case-checking/caseCheckingChrome";

export function RemedialActionsAgentBanner({ ruleOverridesSaved }: { ruleOverridesSaved?: boolean }) {
  return (
    <div
      className={clsx(
        CC_PANEL,
        "border-l-4 border-l-indigo-500/70 bg-indigo-500/[0.04] py-3 dark:bg-indigo-500/10",
      )}
      data-testid="remedial-actions-agent-banner"
    >
      <div className="flex items-start gap-3">
        <FontAwesomeIcon
          icon={faSparkles}
          className="mt-0.5 h-4 w-4 shrink-0 text-indigo-600 dark:text-indigo-300"
        />
        <div className="min-w-0 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
          <p className="font-medium text-slate-800 dark:text-slate-100">Actions for your review</p>
          <p className="mt-1 text-slate-600 dark:text-slate-300">
            This list reflects your guided review: the agent&apos;s baseline plus any edits you save here. When you
            change rule verdicts, coverage gaps update to match your assessment, and actions tied to rules that now
            pass may be auto-removed. Edit, reassign, add, or remove actions here to match your review.
          </p>
          {ruleOverridesSaved ? (
            <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
              You saved rule changes earlier — check coverage gaps above and whether any actions are still needed.
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
